import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import ListHeader from "@/common/components/ListHeader";
import Table from "@/common/components/Table";
import TextField from "@/common/components/TextField";
import useDebounce from "@/common/hooks/useDebounce";
import { useFilterParams } from "@/common/hooks/useFilterParams";
import { Mapper } from "@/common/services/mapper";
import { defaultColumns } from "@/features/permissions/constants/columns.constant";
import { KeyRound, SearchIcon } from "lucide-react";
import { EstablishmentPermissionsTransformer } from "../../services/establishmentPermissionsTransformer";
import { PermissionData, PermissionTableItem } from "@/common/types/permissions";
import { useEstablishmentPermissions } from "../../hooks/useEstablishmentPermissions";

const EstablishmentPermissionsList = () => {
  const { filterParams, setFilterParams } = useFilterParams();

  const [search, setSearch] = useDebounce(filterParams.search || '');

  const {
    data: establishmentPermissions,
    meta: establishmentPermissionsMeta,
    isPending: establishmentPermissionsIsPending,
    isLoading: establishmentPermissionsIsLoading,
    error: establishmentPermissionsError = {} as any,
    refetch: refetchEstablishmentPermissions,
  } = useEstablishmentPermissions({
    filters: {
      search,
      page: filterParams.page || 1,
    },
    mapper: Mapper.mapWithTransformer<PermissionData[], PermissionTableItem[]>({
      transformer: EstablishmentPermissionsTransformer.tableTransformer()
    })
  });

  return (
    <div className="flex flex-col gap-6">
      <ListHeader
        Icon={<KeyRound className="w-10 h-10" strokeWidth={1.5} />}
        title="Permissões - Estabelecimentos"
        createButtonText="Nova permissão"
        dataTestid="create_permission_button"
        operationKlassToCheckPermission="Admin::Establishment::Permissions::Create"
        disableCreateButton={establishmentPermissionsIsPending || establishmentPermissionsError?.status === 403}
      />

      <ErrorMessageWrapper
        className="h-[calc(100vh-128px)]"
        statusCode={establishmentPermissionsError?.status}
        refetchFunction={refetchEstablishmentPermissions}
      >
        <div className="h-[calc(100vh-128px)] flex flex-col gap-6">
          <div className="flex flex-col gap-4">
            <TextField
              name="search"
              LeftIcon={<SearchIcon />}
              placeholder="Pesquisar"
              className="rounded-sm shadow-[4px_0px_16px_0px_rgba(0,_0,_0,_0.5)]"
              onChange={(e) => {
                setSearch((e.target as HTMLInputElement).value);
                setFilterParams((prev) => ({ ...prev, search: (e.target as HTMLInputElement).value }));
              }}
              value={filterParams.search}
            />
          </div>

          <Table
            className="max-h-screen"
            columns={defaultColumns}
            isLoadingData={establishmentPermissionsIsLoading}
            page={filterParams.page || 1}
            rows={establishmentPermissions}
            totalPages={establishmentPermissionsMeta.total_pages}
            totalCount={establishmentPermissionsMeta.total}
            hasPagination
            setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
          />
        </div>
      </ErrorMessageWrapper>
    </div>
  );
};

export default EstablishmentPermissionsList;
